import qs from 'qs';
import { makeRequest, getQueryParams } from 'src/fetch/utils';
import authFetch from 'src/fetch/fetch';

const YARD_PATH = '/api/Yard';

export const getYardsPaginated = async (params) => {
  const query = params && Object.keys(params).length > 0 ? `?${qs.stringify(params, { indices: false })}` : '';
  return makeRequest(authFetch.get(`${YARD_PATH}${query}`));
};

export const getYards = () => getYardsPaginated({
  pageSize: 100,
  page: 1,
  sort: 'yardName',
  order: 1,
}).then(({ data }) => data);

export const getYardById = (yardId) => makeRequest(
  authFetch.get(`${YARD_PATH}/${yardId}`),
);

export const getYardsLookup = () => makeRequest(
  authFetch.get(`${YARD_PATH}/lookup`),
);

export const postYards = (data) => makeRequest(
  authFetch.post(YARD_PATH, data),
);

// Yard Locations
export const getYardLocations = (yardId) => makeRequest(
  authFetch.get(`${YARD_PATH}/${yardId}/locations`),
);

export const saveYardLocation = (yardId, location) => makeRequest(
  authFetch.put(`${YARD_PATH}/${yardId}/locations`, location),
);

export const deleteYardLocation = (yardId, yardLocationId) => makeRequest(
  authFetch.delete(`${YARD_PATH}/${yardId}/locations/${yardLocationId}`),
);

// Yard Users
const YARD_USERS_PATH = '/api/yardUsers';

export const getYardUserNames = () => makeRequest(
  authFetch.get(`${YARD_USERS_PATH}/usernames`),
);

export const getYardUsers = (params) => makeRequest(
  authFetch.get(`${YARD_USERS_PATH}${getQueryParams(params)}`),
);

export const createYardUser = (yardUser) => makeRequest(
  authFetch.post(YARD_USERS_PATH, yardUser),
);

export const createNewPassword = (yardUserId) => makeRequest(
  authFetch.patch(`${YARD_USERS_PATH}/${yardUserId}/password`),
);

export const deleteYardUser = (yardUserId) => makeRequest(
  authFetch.delete(`${YARD_USERS_PATH}/${yardUserId}`),
);

export const restoreYardUser = (yardUserId) => makeRequest(
  authFetch.patch(`${YARD_USERS_PATH}/${yardUserId}/restore`),
);

export const getYardUserAudits = (yardUserId, params) => makeRequest(
  authFetch.get(`${YARD_USERS_PATH}/${yardUserId}/Audits${getQueryParams(params)}`),
);

export const getYardUserAuditProperties = (yardUserId) => makeRequest(
  authFetch.get(`${YARD_USERS_PATH}/${yardUserId}/Audits/Properties`),
);

export const getYardUserAuditUsers = (yardUserId) => makeRequest(
  authFetch.get(`${YARD_USERS_PATH}/${yardUserId}/Audits/Users`),
);

// Others
export const getYardInventory = (params) => makeRequest(
  authFetch.get(`${YARD_PATH}/inventory${getQueryParams(params)}`),
);

export const getOrderYardActivity = (proNumber, params) => makeRequest(
  authFetch.get(`${YARD_PATH}/orders/${proNumber}/movements${getQueryParams(params)}`),
);

export const getOrderItemYardActivity = (proNumber, params, itemNumber) => makeRequest(
  authFetch.get(`${YARD_PATH}/orders/${proNumber}/movements/${itemNumber}${getQueryParams(params)}`),
);


export const getYardHistory = () => makeRequest(
  authFetch.get(`${YARD_PATH}/history`),
);

export const getYardInventoryCounts = () => makeRequest(
  authFetch.get(`${YARD_PATH}/counts`),
);

export const getYardDiscrepancies = (yardId, params) => makeRequest(
  authFetch.get(`${YARD_PATH}/discrepancies-dashboard/${yardId}${getQueryParams(params)}`),
);

export const getYardDiscrepancyDetails = (params) => makeRequest(
  authFetch.get(`${YARD_PATH}/discrepancies${getQueryParams(params)}`),
);

export const getDiscrepancy = (discrepancyId) => makeRequest(
  authFetch.get(`${YARD_PATH}/discrepancies/${discrepancyId}`),
);

export const getYardDiscrepancyFixOptions = (discrepancyId) => makeRequest(
  authFetch.get(`${YARD_PATH}/discrepancies/${discrepancyId}/fixes`),
);

export const upsertYardMovement = (yardMovement) => makeRequest(
  authFetch.put(`${YARD_PATH}/movements`, yardMovement),
);

export const upsertYardItem = (itemDetails) => makeRequest(
  authFetch.put(`${YARD_PATH}/items`, itemDetails),
);

export const deleteYardMovement = (yardMovementId) => makeRequest(
  authFetch.delete(`${YARD_PATH}/movements/${yardMovementId}`),
);

export const getYardInventoryHistory = (params) => makeRequest(
  authFetch.get(`${YARD_PATH}/inventory/history${getQueryParams(params)}`),
);

export const getYardItemHistory = (id, params) => makeRequest(
  authFetch.get(`${YARD_PATH}/inventory/history/${id}${getQueryParams(params)}`),
);

export const applyYardDiscrepancyFix = (id, fix) => makeRequest(
  authFetch.patch(`${YARD_PATH}/discrepancies/${id}/fix`, fix),
);

export const getYardCustomerBreakdown = (params) => makeRequest(authFetch.get(`/api/Yard/history/customerbreakdown${getQueryParams(params)}`));
  
export const getYardPrediction = (yardId) => makeRequest(authFetch.get(`/api/Yard/${yardId}/prediction`));

export const getDiscrepancyMovement = (discrepancyId) => makeRequest(
  authFetch.get(`${YARD_PATH}/discrepancies/${discrepancyId}/movement`),
);

export const deleteYard = (yardId) => makeRequest(
  authFetch.delete(`${YARD_PATH}/${yardId}`),
);
